/*>
* @license
* Copyright (c) 2014-2022 ABILITY Network, Inc., an INOVALON, Inc. company. All Rights Reserved.
* 
* This computer program is CONFIDENTIAL and a TRADE SECRET of ABILITY Network, Inc.
* The receipt or possession of this program does not convey any rights to use,
* reproduce or disclose its contents in whole or in part, without the specific
* written consent of ABILITY Network, Inc. Any use, reproduction or disclosure of
* this program without the express written consent of ABILITY Network, Inc. is a
* violation of the copyright laws and may subject you to criminal prosecution.
<*/
import ILandingPageApiClient from './contracts'
import { injectProperty } from '../../configuration/ServiceLocator'
import { IApiClient } from '../ApiClient/IApiClient'
import { injectable } from 'inversify'

@injectable()
export class LandingPageApiClient implements ILandingPageApiClient {
	@injectProperty('IApiClient')
	private readonly apiClient!: IApiClient

	getProductCategoryList(): Promise<string> {
		return this.apiClient.getCMSToken().catch(error => {
			console.log(error)
			throw new Error('An error occured while fetching the CMS token from Ability Portal.')
		})
	}
}
